module.exports = __webpack_public_path__ + "static/media/paw_prompt_2.dc4b2ad3.mp3";